// `GET /user/company-defaults/access/` — the one answer the UI reads to decide
// what Company Defaults shows and lets a user change.

export const COMPANY_DEFAULTS_BLOCK_ACTIONS = {
  company_wide: ["view", "edit"],
  id_configuration: ["view", "edit"],
  project_list: ["view", "edit"],
  subcontractor_alerts: ["view", "edit"],
  sms_retention: ["view", "edit"],
  sms_send_window: ["view", "edit"],
  status_automation: ["view", "edit"],
  branch_configuration: ["view", "edit", "reset"],
  required_information: ["view", "edit"],
  project_templates: ["view", "create", "edit", "delete"],
  document_templates: ["view", "create", "edit", "delete"],
  email_templates: ["view", "create", "edit", "delete"],
  drop_down_lists: ["view", "create", "edit", "delete"],
  dashboard_templates: ["view", "create", "edit", "delete"],
  lead_source_budget: ["view", "edit"]
} as const

export type CompanyDefaultsBlockKey =
  keyof typeof COMPANY_DEFAULTS_BLOCK_ACTIONS

export type CompanyDefaultsAction =
  | "view"
  | "create"
  | "edit"
  | "delete"
  | "reset"

export type CompanyDefaultsBlockAccess<K extends CompanyDefaultsBlockKey> =
  Record<(typeof COMPANY_DEFAULTS_BLOCK_ACTIONS)[K][number], boolean>

export type CompanyDefaultsBlocks = {
  [K in CompanyDefaultsBlockKey]: CompanyDefaultsBlockAccess<K>
}

export const COMPANY_DEFAULTS_ACCESS_BASES = [
  "owner",
  "admin",
  "platform_admin",
  "permissions",
  "none"
] as const

export type CompanyDefaultsAccessBasis =
  (typeof COMPANY_DEFAULTS_ACCESS_BASES)[number]

export interface CompanyDefaultsAccessResponse {
  team_id: string | null
  company_team_id: string | null
  basis: CompanyDefaultsAccessBasis
  full_access: boolean
  blocks: CompanyDefaultsBlocks
}

export type CompanyDefaultsAccessStatus = "loading" | "ready" | "error"
